module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1048-3d808196c547e6dd919307d67317ae38.png";